/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import 'babel-polyfill'
import api from './config/api'
import {createrRandom, getExpire, getQueryVariable} from './globalFunction';
import './directive'
import indexPop from "./mixin/indexPop";

import {codemirror} from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/clike/clike.js'
import 'codemirror/mode/markdown/markdown.js'
import 'codemirror/mode/python/python.js'
import 'codemirror/mode/r/r.js'
import 'codemirror/mode/shell/shell.js'
import 'codemirror/mode/sql/sql.js'
import 'codemirror/mode/swift/swift.js'
import 'codemirror/mode/vue/vue.js'
import '../sass/empty.css'

import './signCom/index';//引入组件挂载js


import {ajaxAsync} from "./config/ajaxAsync";

import './config/ajaxConfigSetting'
import {copyFun} from './utils/hook'

window.Vue = Vue;
import {
    Message,
    MessageBox,
} from 'element-ui';

Vue.prototype.copyFun = copyFun
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message

Vue.prototype.$ajaxAsync = ajaxAsync;

import InitUMeng from 'spt-umeng'

let initUMeng = new InitUMeng()
initUMeng.setUmId('65dfeafd7ff40d159a764c8b')
window.$initUMeng = initUMeng
Vue.prototype.$initUMeng = initUMeng

import SptAmap from "spt-amap";
import {gaugeSetting} from "./config/setting";
import {tencentCaptchaAppId} from "./config/tencentCaptchConfig";
import th from "element-ui/src/locale/lang/th";
import {companyInfo} from "./config/companyInfo";

let sptAmap = new SptAmap('0707a06737d18678e3ecd6f5a5718cfb', 'https://bigdata.speedtest.cn/_AMapService');
sptAmap.init();
window.sptAmap = sptAmap;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component('codemirror', codemirror);

window.app = new Vue({
    el: '#app',
    mixins: [indexPop],
    data: {
        fiveAlterAdSwitch: false,// 5G弹窗
        tipsAlertSwitch: false, //推荐分成弹窗显示开关
        tipsAlertType: 'kuandai',  //推荐分成类型
        tipsDownload: false,//下载客户端弹窗开关
        changePhoneShow: false,//修改手机号弹窗开关
        downloadAppShow: false, //下载APP弹窗
        showAppDownloadv2: false,
        AppDownloadBgImgType: 1,
        userInfoV3: {},
        // 结果
        resultData: {},
        rankInfo: '', // rank的文案
        // chart
        downloadChart: [],
        uploadChart: [],
        // ip&历史记录
        ip: '',
        loginShow: false,
        downloadApp: false,
        actionShow: false,//活动的开关
        characterLogin: false,//宽带提速的login
        // start
        basicDown: 0,//当前下载网速
        basicUp: 0,//当前的上传网速
        targetDown: 0,//可以提升的下载网速
        targetUp: 0,//可以提升的上传网速
        queryData: {
            buid: ''
        },//提速信息
        downInspeedup: false,//下载提速状态的查询
        upInspeedup: false,//上传提速状态的查询
        // #####
        buid: "",//进行提速的唯一标识
        accelerateLoadingSwitch: false,//提速loading的控制变量
        keepAccelerateLoadingSwitch: false,//提速loading的控制变量,防被打断
        videoSrc: '', //视频地址
        playing: false, //视频播放器开关
        showSpeedtest: false,//是否显示去测速弹窗
        showJiasuSpeedtest: false,//jiasu页面是否显示去测速弹窗
        isAdFree: true,//是否去除广告
        isp: '',
        storeResultData: {},//测速记录保存结果
        showTapeOutAlert: false,
        ipInfo: {},
        tisuIpInfo: null, // 提速的ip信息
        showChangeNodeTip: false,
        showticket618Alert: false,//展示618活动弹窗开关
        jiasuShow618Ticket: false,//提速产品是否展示618优惠券活动
        ticket1amount: 5800,//618优惠券1的优惠金额
        ticket1Min_usable: 20000,//618优惠券1的满足条件
        ticket2amount: 880,//618优惠券2的优惠金额
        ticket2Min_usable: 1000,//618优惠券2的满足条件
        jisuAppDownload: false,//极速版下载弹窗
        showActivityAlert: false,//测速后弹窗
        speedActivityAlertData: {},//测速后弹窗数据
        activityList: null,//测速后所有活动
        pingRunStatus: false, // 执行ping的状态:false.未开始执行，true：执行完毕
        progressStatus: 0,// 测速状态：0未开始，1点击测速，2开始测速，3.连接成功，ping,4下载，5上传，6结束,-1异常
        speedSetting: localStorage.getItem("settings") ?
            JSON.parse(localStorage.getItem("settings")) :
            { //设置相关
                unit: 'Mbps', //单位
                range: 500, //量程
            },
        points: gaugeSetting['Mbps']['500'],//表盘数值范围
        resultLineWidth: 25, // 绘制的最后的canvas的线条宽度
        circleBoxWidth: 350, // 测速最外面盒子激活的宽度
        circleBoxHeight: 350, // 测速外面盒子激活的高度
        speedAddShow: '1',//是否显示加测
        speedScore: [], // 打分数组
        udid: localStorage.getItem('udid') || '',
        usid: '',
        videoPopInitShow: false, // 视频弹窗的接口开关
        videoPopShow: false, // 视频弹窗的测速事件开关
        videoPopBtnSwitch: localStorage.getItem('videoPopBtnSwitch') ? JSON.parse(localStorage.getItem('videoPopBtnSwitch')) : true, // 视频弹窗的按钮控制开关
        showMiniProgramPkAlert: false, //小程序测速pk活动的弹窗
        testEndForm: false, //南京移动测速结束后弹窗表单开关
        isEndShow: false, //南京移动测速结束后弹窗是否展示（根据接口进行判断）
        clickOpen: false,//南京移动测速结束后弹窗是否进行了点击
        testEndFormData: {},//南京移动测速结束后弹窗内容
        showVideoCollection: false, //边走边测视频收集活动弹窗开关
        nowSignBrand: null, // 签约带宽
        speedInfoLevel: null, // 测速结束后的level 0:没有签约宽带 1:达标  2:不达标
        speedInfoSpeedUp: 0, // 测速后提速是否理想 0 未提速 1 理想 2 不理想
        indexInfo: null, // 宽带提速的信息提示
        speedDetailData: null, // 测速详情的内容
        testEndFormType: 0, // 测速后宽带信息弹窗的类型 0：测速后 1：测速详情
        addToolType: 0, // 加测的类型：0 正常测速 1 测速详情
        recordBindUserStatus: false, // 绑定用户记录的状态
        adAllData: null, // 广告的总结合，避免多次调用
        adAllRouteList: ['/', '/result/*', '/share/*'], // 请求多个广告合一的路由
        speedAddList: [], // 加测的项目，0的时候咋说明可以跳转网速报告
        loadingRouteList: ['/jiasu', '/jiasu/boost', '/jiasu/get_coupon', "/tisu-plugin", "/tisu-plugin/setting", "/tisu-plugin/earning", "/tisu-plugin/earning/detail",
            '/adfree/pay', '/activitypage', '/faq', '/faq/detail'], // 进入有loading的路由
        storageSetting: localStorage.getItem("settings") || null, // 缓存中的setting
        loginShowStatus: 0, // login的弹窗方式 0 正常方式 4 绑定手机号的方式
        setTisuOperator: '',//是否改变宽带提速展示运营商
        showDelayAlert: '',//测速结束时延弹窗
        isChuZhouPopShow: false, //滁州联通的弹窗是否展示
        isRequestFinish: false, //滁州联通接口是否调用完成
        chuZhouInfo: null, //滁州联通信息
        tencentCaptchaAppId: tencentCaptchaAppId, // 腾讯防水墙的appid
        indexWebData: {
            fiveGVideos: [],
            sponsorList: [],
        }, //首页web信息
        byteNum: 1000, // 测速单位的基准值，用1000代替1024，但是提速的不变
        nodeInfo: {}, // 节点的信息
        companyInfo, // 公司信息
        showAboutUpVersion:false//展示用户协议隐私政策更新弹窗
    },
    created() {
        this.createdInit();
        this.queryAdNew();
        // 满足天翼急速统计 从他们页面过来下单的数量 当日十二点清除
        if (getQueryVariable('from')) {
            try {
                let time = new Date()
                let currentTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
                let obj = {
                    key: getQueryVariable('from'),
                    time: currentTime
                }
                localStorage.setItem('orderSource', JSON.stringify(obj))
            } catch (e) {

            }
        }
    },
    mounted() {
        this.mountedInit();
    },
    methods: {

        /**
         * points的处理以及udid的处理
         * */
        createdInit() {
            // 获取缓存的setting
            if (this.storageSetting) {
                let storageSettingVal = JSON.parse(this.storageSetting);
                let storageUnit = storageSettingVal['unit'] || 'Mbps';
                let storageRange = storageSettingVal['range'] || '500'
                this.points = gaugeSetting[storageUnit][storageRange]
            }
            if (!this.udid) {
                this.udid = new Date().getTime() + createrRandom();
                localStorage.setItem('udid', this.udid);
            }
        },
        /**
         * 一次性获取多个广告位置
         * */
        queryAdNew() {
            let routeBool = this.adAllRouteList.some((item) => {
                let routeArr = item.split('/*');
                if (routeArr.length > 1) {
                    return window.location.pathname.indexOf(routeArr[0]) > -1
                }
                return window.location.pathname === item;
            })
            if (!routeBool) {
                return;
            }
            api.getAdNew({type: 'web'}).then(res => {
                if (res.data) {
                    this.adAllData = res.data;
                    this.showAdStatistics(res.data)
                }
            })
        },

        showAdStatistics(data) {
            if (data && data.index_top_right && data.index_top_right.length) {
                let index_top_right = data.index_top_right[0]
                if (index_top_right && index_top_right.content) {
                    //调用埋点接口
                    api.buriedPointV3({
                        source: 'www',
                        position: 'www_home_freetest_ahcz_show',
                        type: "show",
                    })
                }
            }

        },

        /**
         * mounted的一堆初始方法
         * */
        async mountedInit() {
            // 当为手机提速页面时，不进行接下来的请求
            if (!window.location.pathname.indexOf("/speedup")) {
                return
            }
            this.retryResultSubmit();
            if (this.showLoading(this.loadingRouteList)) {
                this.changeAccelerateLoading(true);
            }
            // 用户信息的查询
            this.queryUserInfo();
            try {
                this.gainUpReopen();
                this.gainQuery('www-index');
            } catch (e) {
                this.changeAccelerateLoading(false);
            }
        },

        /**
         * 获取个人信息
         * */
        queryUserInfo() {
            this.recordBindUserStatus = false;
            this.loginShowStatus = 0;
            return api.gainUserInfoV3().then(async (res) => {
                this.userInfoV3 = res.data || {login: false};
                this.loginAfterFunc();
                if (this.userInfoV3.id) {
                    this.isAdFree = res.code === 0 && +res.data.isVip === 1 && !getExpire(res.data.vipExpire);
                    if (!this.userInfoV3.nickname) this.userInfoV3.nickname = this.userInfoV3.username;
                    if (localStorage.hasOwnProperty('recordList')) {
                        this.recordBindUser();
                        return;
                    }
                } else {
                    this.isAdFree = false;
                }
                this.recordBindUserStatus = true;
            }).catch(e => {
                this.isAdFree = false;
                this.recordBindUserStatus = true;
            }).finally(() => {
                //加速页面还有多个请求此处不关闭动画
                if (!this.showLoading(['/jiasu'])) {
                    this.changeAccelerateLoading(false);
                }
            })
        },



        /**
         * 登录后的方法
         * */
        loginAfterFunc() {
            if (!this.userInfoV3.id) {
                sessionStorage.removeItem('rowOperateType');
                // 提速插件的跳转
                if (window.location.pathname.indexOf('/tisu-plugin/') !== -1) {
                    window.location.href = "/tisu-plugin";
                }
            } else if (sessionStorage.getItem('goPersonalCenter') &&
                (window.location.pathname === '/' || window.location.pathname.indexOf('/result/') === 0)) {
                // 测速记录的跳转
                sessionStorage.removeItem('goPersonalCenter');
                window.location.href = window.portal_url + '/record';
            }
            this.rowOperateTypeFunc();
            // 登录成功，并且没有绑定手机号码
            if (this.userInfoV3.id && !this.userInfoV3.phone) {
                this.loginShowStatus = 4;
                this.showLogin();
            }
        },


        /**
         * rowOperateType相关的方法
         * */
        rowOperateTypeFunc() {
            if (!sessionStorage.getItem("rowOperateType")) {
                return;
            }
            if (sessionStorage.getItem("rowOperateType").indexOf('make-') > -1) {
                // 赚钱弹窗的显示
                this.showMakeMoney(sessionStorage.getItem("rowOperateType"));
            }
            if (!this.userInfoV3.id) {
                return;
            }
            if (sessionStorage.getItem('rowOperateType') === 'adfreePay') {
                // 会员的购买
                location.href = '/adfree/pay';
            } else if (sessionStorage.getItem('rowOperateType') === 'gotisuPluginEarning') {
                // 提速插件
                location.href = '/tisu-plugin/earning';
            }
            sessionStorage.removeItem('rowOperateType');
        },

        /**
         * 根据当前设置的单位，转换速度值
         */
        convertSpeed(speed) {
            if (speed === '-') return speed;
            if (!+speed) speed = 0;
            if (this.speedSetting.unit === 'MB/s') {
                speed = Math.round(+speed / 8 * 100) / 100;
            } else if (this.speedSetting.unit === 'kB/s') {
                speed = Math.round(+speed / 8 * this.byteNum);
            }
            return speed
        },

        /**
         * 对数值进行处理
         * @param {number|string} req_num 传入的数值（上传下载）
         * @param {boolean} req_result true(表盘速度) false(上传下载速度)
         * @return {array} 返回处理好的数字数组
         * 规则：当为四位数的时候，取整
         * */
        disposeNum(req_num, req_result) {
            let numArr = [];
            if (req_num === "—" || (req_num === "-" && !req_result) || ((+req_num === 0 || isNaN(req_num)) && !req_result)) {
                numArr = ["—"]
            } else if (req_num >= 1000 && req_num < 10000) {
                numArr = [Number.parseInt(req_num).toLocaleString()]
            } else if (req_num >= 10000) {
                let floatNum = ((req_num / 1000).toFixed(2) + "").split(".")[1];
                numArr = [Number.parseInt(req_num / 1000), "." + floatNum + "k"]
            } else {
                if (+req_num === 0 || isNaN(req_num) || (req_num === "-" && req_result)) {
                    numArr = [0, ".0"]
                } else {
                    req_num = req_num + "";
                    numArr = [Number.parseInt(req_num), "." + (req_num.split(".")[1] === undefined ? 0 : req_num.split(".")[1])]
                }
            }
            return numArr;
        },


        /**
         * 进行赚钱弹窗的显示
         * @param {string} req_type
         * */
        showMakeMoney(req_type) {
            this.tipsAlertType = req_type.split("-")[1];
            this.tipsAlertSwitch = true;
            sessionStorage.removeItem("rowOperateType");
        },

        /**
         * 是否显示加载loading
         * */
        showLoading(list) {
            if (list.indexOf(window.location.pathname) !== -1) {
                return true;
            }
            for (let i = 0; i < list.length; i++) {
                if (list[i][0] === '*' && window.location.pathname.indexOf(list[i].slice(1, -1)) > -1) {
                    return true;
                }
            }
            return false;
        },

        /**
         * 获取活动列表
         * */
        gainActivityList() {
            api.activityList().then((res) => {
                if (res.code === 0) {
                    this.activityList = res.data;
                }
            })
        },


        /**
         * 显示下载客户端弹窗
         * **/
        showDownloadTips() {
            this.tipsDownload = true;
            api.buriedPoint({
                source: 'www',
                operate: 'speed_end_download_alert'
            });
        },

        /**
         * 显示下载极速版弹窗
         * */
        showJisuAppDownloadTips() {
            this.jisuAppDownload = true;
            api.buriedPoint({
                source: 'www',
                operate: 'speed_end_jisuapp_download_alert'
            });
        },


        /**
         * 修改个人信息手机号
         * **/
        changeUserInfoPhone(val) {
            this.userInfoV3.phone = val;
        },


        /**
         * 修改手机号弹窗状态
         * */
        targetChangePhoneShow(result) {
            this.changePhoneShow = result;
        },


        /**
         * 修改活动的显示状态
         * **/
        changeAction(result) {
            this.actionShow = result
        },

        /***
         * 修改自动测速状态
         * @param {boolean} result 结果值
         * */
        changeAutoSpeed(result) {
            if (result) {
                localStorage.setItem("autoSpeed", "1");//是否自动进行测速
                window.open(`${window.location.origin}`)
            }
        },


        /**
         * 修改提速loading的状态
         * **/
        changeAccelerateLoading(result) {
            this.accelerateLoadingSwitch = result
        },


        /**
         * 查询宽带状态
         * */
        gainQuery(source) {
            return api.getSpeedupQuery({
                type: 1,
                source: source ? source : 'www'
            }).then(res => {
                try {
                    let {basicDown, basicUp, targetDown, targetUp} = res.data;
                    this.basicDown = +basicDown;
                    this.basicUp = +basicUp;
                    this.targetDown = +targetDown;
                    this.targetUp = +targetUp;
                    this.buid = res.data.buid || "";
                    this.queryData = res.data;
                    this.gainStatus(res.data);
                    // 根据提速显示表盘相关内容
                    this.speedUpDial();
                } catch (e) {

                }
            })
        },

        /**
         * 提速与表盘相关的逻辑
         * */
        speedUpDial() {
            // 如果有缓存的量程设置或者获取不到宽带信息或者不是首页的时候，则不用提速的逻辑
            if (localStorage.getItem('rangeIndex') || !this.queryData.basicDown || window.location.pathname !== "/") {
                return;
            }
            let nowTrialT = (new Date().getTime()) / 1000;
            let contrastDownload = (this.queryData.downExpireT > nowTrialT || this.queryData.downExpireTrialT > nowTrialT ||
            this.queryData.downUp50ExpireT > nowTrialT || this.queryData.downUp50ExpireTrialT > nowTrialT ||
            this.queryData.downUpExpireT > nowTrialT || this.queryData.downUpExpireTrialT > nowTrialT
                ? this.queryData.targetDown : this.queryData.basicDown) / 1024;
            let range = Object.keys(gaugeSetting[this.speedSetting.unit])[2];
            if (contrastDownload <= 100) {
                this.points = Object.values(gaugeSetting[this.speedSetting.unit])[0];
                range = Object.keys(gaugeSetting[this.speedSetting.unit])[0];
            } else if (contrastDownload <= 300) {
                this.points = Object.values(gaugeSetting[this.speedSetting.unit])[1];
                range = Object.keys(gaugeSetting[this.speedSetting.unit])[1];
            } else if (contrastDownload <= 500) {
                this.points = Object.values(gaugeSetting[this.speedSetting.unit])[2];
                range = Object.keys(gaugeSetting[this.speedSetting.unit])[2];
            } else {
                this.points = Object.values(gaugeSetting[this.speedSetting.unit])[3];
                range = Object.keys(gaugeSetting[this.speedSetting.unit])[3];
            }
            this.speedSetting.range = +range;
        },


        /**
         * 提速状态查询
         * @param {Object} req_data
         * */
        gainStatus(req_data) {
            let nowDate = new Date().getTime();
            //上传
            if (req_data.upExpire) {
                this.upInspeedup = req_data.upExpireT * 1000 >= nowDate;
            }
            //下载
            if (req_data.downExpire) {
                this.downInspeedup = req_data.downExpireTrial * 1000 >= nowDate;
            }
            if (req_data.indexInfo) {
                this.indexInfo = req_data.indexInfo;
            }
        },

        /**
         * 进行重拨
         * @param {number} req_type 类型(1.上传 2.下载)
         * */
        gainUpOpen(req_type) {
            api.gainUpOpen({
                buid: this.buid,
                type: req_type,
                trial: 0,
                source: "www"
            })
        },

        /**
         * 路由器重拨
         * **/
        gainUpReopen() {
            api.gainUpReopen()
        },


        /**
         * 打开登录
         * */
        showLogin() {
            this.loginShow = true;
        },

        /**
         * 关闭登录
         * */
        hideLogin() {
            this.loginShow = false;
        },

        /**
         * 打开下载app弹窗
         * */
        showDownloadApp() {
            this.downloadApp = true;
        },

        /**
         * 关闭下载app弹窗
         * */
        hideDownloadApp() {
            this.downloadApp = false;
        },


        toggleCharacterLogin(result) {
            this.characterLogin = result;
        },


        /**
         * 本地测速数据进行上传
         * */
        retryResultSubmit() {
            if (localStorage.getItem('location_results')) {
                let results = JSON.parse(localStorage.getItem('location_results'));
                if (results.length) {
                    api.telemetry(results[0]).finally(() => {
                        results.shift();
                        if (results.length === 0) {
                            localStorage.removeItem('location_results');
                        } else {
                            localStorage.setItem('location_results', JSON.stringify(results));
                            this.retryResultSubmit();
                        }
                    })
                }
            }
        },

        /**
         * 获取评分类型
         * */
        getScoreType() {
            api.getScoreType({
                source: 'www',
                network: 1,
                udid: this.udid
            }).then((res) => {
                this.speedScore = res.data;
            })
        },

        /**
         * 登陆后绑定登陆前的测速数据
         * */
        async recordBindUser() {
            let recordList = JSON.parse(localStorage.getItem('recordList'));
            let paramsRecord = recordList.reduce((initArr, item) => {
                initArr = [...initArr, item.id];
                return initArr;
            }, []);
            try {
                let res = await api.resultSetUser({ids: JSON.stringify(paramsRecord)});
                if (!res.code) {
                    localStorage.removeItem('recordList');
                }
                this.recordBindUserStatus = true;
            } catch (e) {
                this.recordBindUserStatus = true;
            }
        },

    }
});



// WEBPACK FOOTER //
// ./resources/js/app.js